function getChatServerBaseUrl(): string {
  const baseUrl = process.env.NEXT_PUBLIC_CHAT_SERVER_BASE_URL?.trim();
  if (!baseUrl) {
    throw new Error(
      "Missing NEXT_PUBLIC_CHAT_SERVER_BASE_URL. Configure the dashboard chat transport to point to apps/server."
    );
  }

  return baseUrl.replace(/\/$/, "");
}

export function buildChatServerUrl(pathname: string): string {
  const normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return `${getChatServerBaseUrl()}${normalizedPath}`;
}
